import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Select,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";

const AddEditLecture = (props) => {
  const navigate = useNavigate();
  const { id, lectureId } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    price: "",
    nameAr: "",
    nameEn: "",
    isActive: true,
  });
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setTitleEnError("");
  };
  const [titleEnError, setTitleEnError] = useState("");
  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setTitleArError("");
  };
  const [titleArError, setTitleArError] = useState("");

  const handleChangePrice = (newValue) => {
    setItem({ ...item, price: newValue });
    setPriceError("");
  };
  const [priceError, setPriceError] = useState("");

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload actionHint={"Accepts jpegs, pngs and svgs"} />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
    // setIsImageUploading(true);

    // const form_data = new FormData();
    // form_data.append("entity_type", "lecture");
    // form_data.append("image", files[files.length - 1]);
    // axios
    //   .post("/s3/save-file", form_data)
    //   .then((res) => {
    //     setIsImageUploading(false);
    //     setItem({
    //       ...item,
    //       image:
    //         validImageTypes.indexOf(files[files.length - 1].type) > 0
    //           ? window.URL.createObjectURL(files[files.length - 1])
    //           : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    //     });
    //     imageKey.current = res.data.data.file_key;
    //     setImageError("");
    //   })
    //   .catch((err) => console.log(err));
  };
  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/lectures/${lectureId}`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            nameEn:
              result?.data?.data?.name && result?.data?.data?.name?.en
                ? result.data.data.name.en
                : "",
            nameAr:
              result?.data?.data?.name && result?.data?.data?.name?.ar
                ? result.data.data.name.ar
                : "",
            price:
              result?.data?.data?.price !== null
                ? String(result.data.data.price)
                : "",
            isActive: result?.data?.data?.is_active ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);

  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/lectures/${lectureId}`)
      .then((result) => {
        navigate(`/admin/courses/${id}/lectures`);
      })
      .catch((err) => console.log(err));
  };
  const [error, setError] = useState("");

  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Lecture`}
      backAction={{ onAction: () => navigate(`/admin/courses/${id}/lectures`) }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.nameEn}
              onChange={handleChangeNameEn}
              label="Name En"
              requiredIndicator
              error={titleEnError}
            />
            <TextField
              value={item.nameAr}
              onChange={handleChangeNameAr}
              label="Name Ar"
              align="right"
              requiredIndicator
              error={titleArError}
            />
          </FormLayout.Group>
          <Select
            label="Price (KWD)"
            options={[
              { label: "0", value: "0" },
              { label: "5", value: "5" },
              { label: "10", value: "10" },
              { label: "15", value: "15" },
              { label: "20", value: "20" },
              { label: "25", value: "25" },
              { label: "30", value: "30" },
              { label: "35", value: "35" },
              { label: "40", value: "40" },
              { label: "45", value: "45" },
              { label: "50", value: "50" },
              { label: "55", value: "55" },
              { label: "60", value: "60" },
            ]}
            onChange={handleChangePrice}
            value={item.price}
            placeholder="Please select"
            requiredIndicator
            error={priceError}
          />
          {/* <TextField
            value={item.price}
            onChange={handleChangePrice}
            label="Price"
            type="number"
          /> */}
          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
          <InlineError message={error} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              Delete
            </Button>
          )
        }
      />

      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.nameEn || !item.nameAr || item.price === "") {
      !item.nameEn && setTitleEnError("This field is required");
      !item.nameAr && setTitleArError("This field is required");
      item.price === "" && setPriceError("Please enter a price");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.nameEn && form_data.append("name[en]", item.nameEn);
      item.nameAr && form_data.append("name[ar]", item.nameAr);
      form_data.append("price", item.price);
      form_data.append("is_active", item.isActive ? 1 : 0);
      form_data.append("course_id", id);
      props?.type === "edit" && form_data.append("_method", "PATCH");
      props.type === "add"
        ? axios
            .post(`/lectures`, form_data)
            .then((result) => {
              navigate(`/admin/courses/${id}/lectures`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/lectures/${lectureId}`, form_data)
            .then((result) => {
              // toggleActive();
              navigate(`/admin/courses/${id}/lectures`);
            })
            .catch((error) => {
              setIsSaving(false);
              setError(error.response.data.message);
            });
    }
  }
};

export default AddEditLecture;
